import { __rest } from "tslib";
import * as React from 'react';
import { DropdownToggle, DropdownContext } from '../Dropdown';
export var OptionsMenuToggle = function OptionsMenuToggle(_a) {
  var _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$parentId = _a.parentId,
      parentId = _a$parentId === void 0 ? '' : _a$parentId,
      _a$toggleTemplate = _a.toggleTemplate,
      toggleTemplate = _a$toggleTemplate === void 0 ? React.createElement(React.Fragment, null) : _a$toggleTemplate,
      _a$hideCaret = _a.hideCaret,
      hideCaret = _a$hideCaret === void 0 ? false : _a$hideCaret,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$isSplitButton = _a.isSplitButton,
      isSplitButton = _a$isSplitButton === void 0 ? false : _a$isSplitButton,
      type = _a.type,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Options menu' : _a$ariaLabel,
      props = __rest(_a, ["isPlain", "isDisabled", "isOpen", "parentId", "toggleTemplate", "hideCaret", "isActive", "isSplitButton", "type", 'aria-label']);

  return React.createElement(DropdownContext.Consumer, null, function (_ref) {
    var contextId = _ref.id;
    return React.createElement(DropdownToggle, Object.assign({}, (isPlain || hideCaret) && {
      toggleIndicator: null
    }, props, {
      isPlain: isPlain,
      isOpen: isOpen,
      isDisabled: isDisabled,
      isActive: isActive,
      id: parentId ? "".concat(parentId, "-toggle") : "".concat(contextId, "-toggle"),
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-expanded": isOpen
    }, toggleTemplate ? {
      children: toggleTemplate
    } : {}));
  });
};